
/**
 * Public configuration for the practitioner signup flow.
 *
 * The Supabase URL and anon/publishable key are intentionally included
 * in the browser bundle. These are PUBLIC Supabase credentials.
 *
 * NEVER put any of these in this file:
 * - Supabase service_role key
 * - Supabase secret key (sb_secret_...)
 * - Stripe secret key (sk_...)
 * - Stripe webhook secret (whsec_...)
 */

const supabaseUrl = 'https://fstskfhauinacivdqfbd.supabase.co'

const supabaseAnonKey = 'sb_publishable_d2zx_wCqblb0PjP4Zhte-Q_hNnSu_hB'

const createAccountFunction = 'create-practitioner-account'

const checkoutFunction = 'create-practitioner-subscription'

export const integrationConfig = {
  supabaseUrl,
  supabaseAnonKey,
  createAccountFunction,
  checkoutFunction,
  termsOfServiceUrl: '/terms-of-service',
} as const

export const passwordMinLength = 8

export const practitionerRoutes = {
  landing: '/practitioners',
  join: '/practitioners/join',
  membership: '/practitioners/membership',
  welcome: '/practitioners/welcome',
} as const

/**
 * Kept for compatibility with older code.
 *
 * The current subscription flow uses the Stripe payment form
 * rather than redirecting directly to Stripe Checkout.
 */
export const stripeCheckoutOrigin = 'https://checkout.stripe.com'

/**
 * Prevent the application from accidentally running with a
 * privileged Supabase key.
 */
function isPrivilegedKey(key: string): boolean {
  if (key.startsWith('sb_secret_')) {
    return true
  }

  const parts = key.split('.')

  if (parts.length < 2) {
    return false
  }

  try {
    const payload = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')

    const decoded = JSON.parse(atob(payload)) as {
      role?: string
    }

    return decoded.role === 'service_role'
  } catch {
    return false
  }
}

export function isBackendConfigured(): boolean {
  return Boolean(
    integrationConfig.supabaseUrl &&
      integrationConfig.supabaseAnonKey &&
      !isPrivilegedKey(integrationConfig.supabaseAnonKey)
  )
}

